export const useBlogPostLinkType = (id: string): BlogPostType =>
    id === undefined ? 'magazine' : 'blog'
